export default __webpack_public_path__ + "static/media/computer-screen.ee213207.svg";